import {Link} from 'react-router'

import {Header as CoreHeader, type HeaderSearchSlot} from '@core/wall/ui/Header'
import {UserBlock} from '@core/auth-ui/UserBlock/UserBlock'

import {ToileMark} from '@product/toile/components/ToileMark'
import styles from './Header.module.scss'

/** What the wall hands the header: its `q` and the setter (`Wall.tsx`'s `renderHeader`). Kept as
 *  its own export for anything still naming it, aliasing the shared shell's own slot type. */
export type HeaderSearch = HeaderSearchSlot

/**
 * Toile's own slots on the shared wall header (`@core/wall/ui/Header`, plan
 * `2026_09_17_ovid_one_wall.md`): the mark + wordmark, the two nav doors (`Packs`, `Tools`), and the
 * right rail (`UserBlock`, `@core/auth-ui`, carrying both doors in its menu on a phone and
 * `/auth/login` as its anonymous door).
 *
 * `accent` and `search` are this component's own contract, unchanged for every existing caller
 * (`PackLandingTemplate`, `_layout.packs.tsx`, `_layout.terms.tsx`, `_layout.privacy.tsx`,
 * `_layout._index.tsx`) — the shared shell underneath is new, this file's own surface is not.
 */
export function Header({accent, search}: {accent?: 'packs' | 'tools' | null; search?: HeaderSearch}) {
    return (
        <CoreHeader
            brand={
                <>
                    <ToileMark size={22} />
                    <span className={styles.word}>toile</span>
                </>
            }
            search={search}
            nav={
                <>
                    <Link to="/packs" className={accent === 'packs' ? styles.navLinkOn : styles.navLink}>
                        Packs
                    </Link>
                    <Link to="/tools" className={accent === 'tools' ? styles.navLinkOn : styles.navLink}>
                        Tools
                    </Link>
                </>
            }
            right={
                <UserBlock
                    extraLinks={[
                        {href: '/packs', label: 'Packs', phoneOnly: true},
                        {href: '/tools', label: 'Tools', phoneOnly: true},
                    ]}
                    signIn={{href: '/auth/login'}}
                />
            }
        />
    )
}
